/* cb-sachets-gift - wires the free-sachets bar toggle and mounts the sachet sticker into the first gallery image on Horizon
   product pages (snippets/cb-sachets-gift.liquid renders the <template>). JS-mounted with a MutationObserver re-mount because
   Horizon morphs the product section on variant change. No core file edits. Sitewide free sachets, 2026-09-08.
   REVERSIBLE: delete this asset + the snippet. */
(function () {
  'use strict';
  if (window.__cbSgInit) return;
  window.__cbSgInit = true;

  function wireToggles() {
    document.querySelectorAll('[data-cb-sg]').forEach(function (box) {
      if (box.dataset.init) return;
      box.dataset.init = '1';
      var btn = box.querySelector('[data-cb-sg-toggle]'), det = box.querySelector('[data-cb-sg-detail]');
      if (!btn || !det) return;
      btn.addEventListener('click', function () {
        var open = det.hidden;
        det.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* First media container of each gallery layout present (Horizon renders a slideshow and/or a grid). */
  function hosts() {
    var out = [], seen = [];
    var sel = [
      '.product-information__media slideshow-slide .product-media-container',
      '.product-information__media .media-gallery__grid .product-media-container',
      '.product-information__media .product-media-container'
    ];
    sel.forEach(function (s) {
      var el = document.querySelector(s);
      if (el && seen.indexOf(el) < 0) { seen.push(el); out.push(el); }
    });
    return out;
  }

  function mountSticker() {
    var tpl = document.querySelector('template[data-cb-sg-sticker]');
    if (!tpl) return;
    hosts().forEach(function (host) {
      if (host.querySelector('[data-cb-sg-sticker-el]')) return;
      host.appendChild(tpl.content.cloneNode(true));
    });
  }

  var timer = null;
  function run() {
    clearTimeout(timer);
    timer = setTimeout(function () { wireToggles(); mountSticker(); }, 80);
  }
  try {
    new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
